import React, { useEffect } from 'react';
import { useUserAlertNotificationsFlow } from '../../../hooks/useUserAlertNotificationsFlow/useUserAlertNotificationsFlow';
import { useAlertNotificationStyles } from './AlertNotification.styles';

export interface IUserAlertNotification {
    onIsActive: (isActive: boolean) => void;
}

export const UserAlertNotification = ({ onIsActive }: IUserAlertNotification) => {
    const { userAlertNotification } = useUserAlertNotificationsFlow();
    const classes = useAlertNotificationStyles();
    const hasAction = userAlertNotification?.action;

    useEffect(() => {
        if (hasAction) {
            onIsActive(true);
        }
    }, [hasAction]);

    return (
        <div data-signa="alert-notification-container" className={classes.root}>
            {hasAction && userAlertNotification?.action()}
        </div>
    );
};
